module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman.d0e4cbf2.jpg";